import React from 'react';
import FISFourm from './FISFourm';
import USSAFourm from './USSAFourm';
import Documentation from './Documentation'
import CombinedForm from './v2/CombinedForm';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


function App() {
  return (
    <Router>
      <Routes>
        {/* v2 is the primary landing page */}
        <Route path="/" element={<CombinedForm/>} />
        {/* Legacy routes accessible via Tools menu */}
        <Route path="/fis" element={<FISFourm/>} />
        <Route path="/ussa" element={<USSAFourm/>} />
        <Route path="/documentation" element={<Documentation/>} />
        {/* Keep /both for backwards compat */}
        <Route path="/both" element={<CombinedForm/>} />
      </Routes>
    </Router>
  );
}

export default App;
